import React from 'react';
import { Button, FlexContainer, FlexItem } from '@placer-ui/components';
import { RequestPropertyFormProps } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledInputField } from 'components/controlled-input-field';

export type UpdatePropertyNameFormValues = {
    name: string;
};

export const UpdatePropertyName = ({ onNextHandler, item }: RequestPropertyFormProps) => {
    const formController = useForm<UpdatePropertyNameFormValues>({
        defaultValues: {
            name: item?.entity_name ?? '',
        },
        mode: 'onBlur',
    });

    const handleSubmit = (data: UpdatePropertyNameFormValues) => {
        onNextHandler?.(data);
    };

    const updatedName = formController.watch('name');
    const isSubmitDisabled = !formController.formState.isValid || item?.entity_name === updatedName;

    return (
        <FormProvider {...formController}>
            <form onSubmit={(ev) => ev.preventDefault()} style={{ height: '100%' }}>
                <FlexContainer
                    justifyContent="space-between"
                    gap={16}
                    flexDirection="column"
                    height="100%"
                >
                    <div>
                        <ControlledInputField
                            name="name"
                            label="Name"
                            placeholder="Briefly describe the edit needed"
                            maxLength={100}
                            required
                            asterix
                            testId="ask-review-name"
                        />
                    </div>

                    <FlexItem alignSelf="flex-end">
                        <Button
                            disabled={isSubmitDisabled}
                            variant="primary-gray"
                            size="small"
                            testId="submit-button"
                            onClick={formController.handleSubmit(handleSubmit)}
                        >
                            Confirm
                        </Button>
                    </FlexItem>
                </FlexContainer>
            </form>
        </FormProvider>
    );
};
